if (!customElements.get('foundation-accordion')) {
  customElements.define(
    'foundation-accordion',
    class FoundationAccordion extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.content = this.querySelector('.foundation-accordion__content');
        this.duration = Number(this.dataset.duration) || 260;

        if (!this.details || !this.summary || !this.content) return;

        this.onSummaryClick = this.onSummaryClick.bind(this);
        this.style.setProperty('--foundation-accordion-duration', `${this.duration}ms`);
        this.summary.setAttribute('role', 'button');
        this.summary.setAttribute('aria-expanded', this.details.hasAttribute('open'));

        this.summary.addEventListener('click', this.onSummaryClick);
      }

      disconnectedCallback() {
        this.summary?.removeEventListener('click', this.onSummaryClick);
        clearTimeout(this.animationTimer);
      }

      onSummaryClick(event) {
        event.preventDefault();

        if (this.isAnimating) return;
        this.details.hasAttribute('open') ? this.close() : this.open();
      }

      open() {
        const contentStyles = window.getComputedStyle(this.content);
        const paddingTop = contentStyles.paddingTop;
        const paddingBottom = contentStyles.paddingBottom;

        this.isAnimating = true;
        this.details.setAttribute('open', '');
        this.summary.setAttribute('aria-expanded', 'true');
        this.content.style.overflow = 'hidden';
        this.content.style.height = '0px';
        this.content.style.paddingTop = '0px';
        this.content.style.paddingBottom = '0px';

        requestAnimationFrame(() => {
          this.content.style.paddingTop = paddingTop;
          this.content.style.paddingBottom = paddingBottom;
          this.content.style.height = `${this.content.scrollHeight}px`;
          this.finishAnimation(() => {
            this.content.style.height = '';
            this.content.style.overflow = '';
            this.content.style.paddingTop = '';
            this.content.style.paddingBottom = '';
          });
        });
      }

      close() {
        const contentStyles = window.getComputedStyle(this.content);

        this.isAnimating = true;
        this.summary.setAttribute('aria-expanded', 'false');
        this.content.style.overflow = 'hidden';
        this.content.style.height = `${this.content.getBoundingClientRect().height}px`;
        this.content.style.paddingTop = contentStyles.paddingTop;
        this.content.style.paddingBottom = contentStyles.paddingBottom;
        this.content.offsetHeight;

        requestAnimationFrame(() => {
          this.content.style.paddingTop = '0px';
          this.content.style.paddingBottom = '0px';
          this.content.style.height = '0px';
          this.finishAnimation(() => {
            this.details.removeAttribute('open');
            this.content.style.height = '';
            this.content.style.overflow = '';
            this.content.style.paddingTop = '';
            this.content.style.paddingBottom = '';
          });
        });
      }

      finishAnimation(callback) {
        const done = () => {
          clearTimeout(this.animationTimer);
          this.content.removeEventListener('transitionend', onTransitionEnd);
          this.isAnimating = false;
          callback();
        };

        const onTransitionEnd = (event) => {
          if (event.target === this.content) done();
        };

        clearTimeout(this.animationTimer);
        this.content.addEventListener('transitionend', onTransitionEnd);
        this.animationTimer = setTimeout(done, this.duration + 80);
      }
    }
  );
}
